// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__J8SEo","menu":"Layout_menu__nu8HZ","main":"Layout_main__anawZ","header":"Layout_header__Fp+HE","content":"Layout_content__O9D1l","footer":"Layout_footer__ECZk0"};